import styled from 'styled-components';

import { LoggedoutView as LoggedOutViewComponent } from '@xingternal/platform-layout-logged-out';
import { ZenViewGridLess } from '@xingternal/platform-layout-zen';

export const LoggedOutView = styled(LoggedOutViewComponent)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const ZenView = styled(ZenViewGridLess)`
  margin: 0;
  display: flex;
  flex-direction: column;
`;
